import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import Preloader from '../../components/Preloader';
import Banner from '../../components/Banner';
import Listing from './Listing';
import { capitalizeWords } from '../../utils/Helper';

/**
 * Tags Page Component
 * Renders blog posts associated with a specific tag.
 */
const Tags = () => {
    const { slug } = useParams();

    // Derived title from URL slug (e.g., "react-js" => "React Js")
    const formattedTitle = React.useMemo(() => {
        if (!slug) return '';
        return capitalizeWords(slug.replace(/-/g, ' '));
    }, [slug]);

    // Apply body class on mount and cleanup on unmount
    useEffect(() => {
        document.body.classList.add('inner-page', 'blog');
        return () => {
            document.body.classList.remove('inner-page', 'blog');
        };
    }, []);

    return (
        <>
            <Preloader />
            <Banner page={{ title: `Tag: ${formattedTitle}` }} />
            <Listing type="tag" />
        </>
    );
};

export default Tags;
